// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yb7u","col":"styles_col__2XE9i"};